import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(4),
  },
  navButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1rem 0',
  },
  price_item: {
    alignItems: 'right',
    display: 'flex',
  },
}));
